<template lang="pug">
  .jumbo
    .bg
      img(v-if="config.jumbo.img" :src="config.jumbo.img", alt="")
      VideoPlayer(v-if="config.jumbo.video" :video="content/loop-bg-uss.mp4")
    .content
      h1
        Logo(:brand="config.front")
        | {{config.jumbo.under}}

      h4(v-if="config.undertitle") {{config.jumbo.undertitle}}
</template>
<script>
import { mapState } from 'vuex'
import VideoPlayer from '@/components/VideoPlayer'
import Logo from '@/components/Logo'

export default {
  components: {
    VideoPlayer,
    Logo
  },
  computed: mapState([
    'config'
  ])
}
</script>

<style lang="scss" scoped>
  .jumbo{
    position: relative;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    .bg{
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      overflow: hidden;
      img{
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      &:after{
        content:  '';
        position: absolute;
        height: 60vh;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(transparent, rgba(0,0,0,0.6));
      }
    }
    .content{
      position: relative;
      z-index: 2;
      max-width: 60vw;
      text-align: center;
      padding: 1rem;
      @media (max-width: 800px){
        max-width: 90vw;
      }
      h1{
        font-weight: 600;
        line-height: 100%;
        letter-spacing: -3px;
        font-family: 'col', sans-serif;
        text-shadow: 1px 1px 1px black;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        @include fluid-type(360px,
          1440px,
          48px,
          72px);
        color: white;
        //
        span{
          text-transform: uppercase;
          display: block;
          font-weight: 800;
          line-height: 100%;
          @include fluid-type(360px,
          1440px,
          64px,
          100px);
          margin: 0;
        }
      }
      h4{
        color: white;
        @include fluid-type(360px,
          1440px,
          16px,
          26px);
      }
    }
    height: 80vh;
  }
</style>
